import Vue from 'vue'

import {
  decode
} from 'utils/general'

export default el => Promise.all([
]).then(() => new Vue({
  el,
  data () {
    return {
      videoElement: null,
      paused: null,
      isMuted: true,
      isActive: false,
      active: false,
      videos: {}
    }
  },
  computed: {
    playing () { return !this.paused },
    activeVideo () {
      return this.videos[this.active]
    }
  },
  mounted () {
    this.videos = JSON.parse(decode(this.$el.dataset.videos))
    this.active = this.$el.dataset.active
    console.log(this.active)
  },
  methods: {
    setActive (id) {
      this.active = id
    },
    updatePaused (event) {
      this.videoElement = event.target
      this.paused = event.target.paused
    },
    play () {
      this.videoElement.play()
    },
    pause () {
      this.videoElement.pause()
    },
    toggleMute () {
      this.isActive = !this.isActive
      var vid = this.$refs.video
      vid.muted = !vid.muted
    }
  }
}))
